import React from 'react';
import { Table, Popover } from 'antd';
import { formatTimestamp, formatPrice } from 'utils/utils.js';
import { connect } from 'dva';

@connect(({ merchantCommodityDetail, loading }) => ({
  shelfSchools: merchantCommodityDetail.detail.shelfSchools,
  commodityId: merchantCommodityDetail.detail.commodityId,
  loading: loading.effects['merchantCommodityDetail/fetchRelateSchools'],
}))
export default class RelateSchoolsTable extends React.Component {
  componentDidMount() {
    const { dispatch, commodityId } = this.props;

    if (commodityId) {
      dispatch({
        type: 'merchantCommodityDetail/fetchRelateSchools',
        commodityId,
      });
    }
  }

  render() {
    const { shelfSchools, loading } = this.props;

    const columns = [
      {
        title: '序号',
        dataIndex: 'id',
        render: (text, record, index) => index + 1,
      },
      {
        title: 'School ID',
        dataIndex: 'orgId',
      },
      {
        title: '名称',
        dataIndex: 'orgName',
      },
      {
        title: '售价（元）',
        dataIndex: 'minPrice',
        render: (text, record) => {
          if (record.minPrice === record.maxPrice) {
            return `¥${formatPrice(record.minPrice)}`;
          }

          const skusComponents = (
            <section>
              {record.skus.map(sku => {
                return (
                  <div key={`${sku.properties}：${sku.price}`}>
                    {sku.properties}：¥{formatPrice(sku.price)}
                  </div>
                );
              })}
            </section>
          );

          return (
            <Popover content={skusComponents} placement="bottom">
              <a>
                ¥{formatPrice(record.minPrice)} - {formatPrice(record.maxPrice)}
              </a>
            </Popover>
          );
        },
      },
      {
        title: '上架日期',
        dataIndex: 'date',
        render: val => formatTimestamp(val),
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={shelfSchools}
        rowKey="orgId"
        loading={loading}
        bordered
        pagination={false}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Commodity/components/RelateSchoolsTable.js